import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MenuModule } from '@progress/kendo-angular-menu';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PDFViewerModule } from '@progress/kendo-angular-pdfviewer';
import { PopupModule } from '@progress/kendo-angular-popup';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TypographyModule } from '@progress/kendo-angular-typography';
import {
  AuthModule,
  StsConfigLoader,
  StsConfigStaticLoader,
} from 'angular-auth-oidc-client';
import 'hammerjs';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './content/layout/footer/footer.component';
import { HeaderComponent } from './content/layout/header/header.component';
import { NavigationComponent } from './content/layout/navigation/navigation.component';
import { PagesComponent } from './content/pages/pages.component';
import { HeaderInterceptor } from './interceptors/header-interceptor';
import { StudentSearchModule } from './modules/student-search/student-search.module';
import 'hammerjs';
import { PopoverModule } from '@progress/kendo-angular-tooltip';
import { NotificationContentComponent } from './modules/dashboard/components/notification-content/notification-content.component';
import { NotificationComponent } from './modules/dashboard/components/notification/notification.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { MarkingWarnComponent } from './modules/dashboard/components/marking-warn/marking-warn.component';

import { AppConfigService } from './services/app-config.service';
import { StudentInfoModule } from './modules/student-info/student-info.module';

export function configFactory(appConfigService: AppConfigService) {
  return () => appConfigService.loadConfig();
}

export function config(configService: AppConfigService) {
  const config = configService.getConfig().authSettings;
  return new StsConfigStaticLoader(config);
}

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    HeaderComponent,
    FooterComponent,
    NavigationComponent,
    NotificationContentComponent,
    NotificationComponent,
    MarkingWarnComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StudentSearchModule,
    NotificationModule,
    RippleModule,
    LabelModule,
    LayoutModule,
    NavigationModule,
    IndicatorsModule,
    MenuModule,
    PopupModule,
    IconsModule,
    TextBoxModule,
    DropDownListModule,
    FormsModule,
    ReactiveFormsModule,
    PDFViewerModule,
    TypographyModule,
    ButtonsModule,
    DialogsModule,
    InputsModule,
    TooltipModule,
    TimePickerModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    EditorModule,
    AuthModule.forRoot({
      loader: {
        provide: StsConfigLoader,
        useFactory: config,
        deps: [AppConfigService],
      },
    }),
    FontAwesomeModule,
    PopoverModule,
    GridModule,
    StudentInfoModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: configFactory,
      deps: [AppConfigService],
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
